import React, { useContext, useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";
import InfiniteScroll from 'react-infinite-scroll-component';
import { CardsSlider } from "../../../../components/CardsSlider";
import { CardsContext } from "../../CardsContext";
import { SectionHead } from '../../../../components/SectionHead/SectionHead';
import { Card } from '../../../../components/Card';
import { sendPageViewEvent } from '../../../../utils/utils';
import { isCardContinueWatching } from '../../../../utils/cards';
import './ContinueWatchingPage.scss';

export function ContinueWatchingPage({ onToggleWatchLater, onBack }) {
  const { target, isTargetClasses, cards, cardsConfig } = useContext(CardsContext);
  const location = useLocation();
  const [current, setCurrent] = useState(1)

  useEffect(() => {
    sendPageViewEvent('Continue watching');
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }, [location.pathname]);

  const progressCards = cards.filter((card) => isCardContinueWatching(card));
  const progressSeriesCards = cards.filter((card) => card.series.length && card.series.some((seria) => isCardContinueWatching(seria)));

  if(!progressCards.length && !progressSeriesCards.length) {
    return <p className="no-data">No continue watching</p>;
  }

  const visibleProgressCards = progressCards.slice(0, current * 10);

  return (
    <div>
      <SectionHead
        title="Continue Watching"
        count={progressCards.length + progressSeriesCards.length}
        action={{
          type: 'button',
          children: 'Back',
          arrow: 'left',
          onClick: onBack
        }}
      />

      {!!progressSeriesCards.length && (
        <CardsSlider
          addPopupSeriesSearchParam
          isShowDate={isTargetClasses}
          isShowWatchLater={cardsConfig.watchLater}
          type={target}
          cards={progressSeriesCards}
          className="ContinueWatchingPage__series"
        />
      )}

      {!!progressCards.length && (
        <InfiniteScroll
          dataLength={visibleProgressCards.length}
          next={() => setCurrent((prevCurrent) => prevCurrent + 1)}
          hasMore={visibleProgressCards.length < progressCards.length}
          loader={<h4>Loading...</h4>}
          endMessage={null}
        >
          {visibleProgressCards.map((cardItem) => (
            <Card
              isRow
              isShowWatchLater={cardsConfig.watchLater}
              type={target}
              cardItem={cardItem}
              key={cardItem.id}
              onToggleWatchLater={onToggleWatchLater}
            />
          ))}
        </InfiniteScroll>
      )}
    </div>
  );
}
